import { createAsyncThunk } from '@reduxjs/toolkit';

import { APILicenseUserGroupsGet } from './LicenseUserGroups.api';

export const fetchLicenseUserGroups = createAsyncThunk('license/fetchUserGroups', async (params: {
    tenantId: string,
    licenseId: string,
    signal?: AbortSignal
}) => {
    const response = await APILicenseUserGroupsGet(params);
    return response.data;
});
